module.exports = __webpack_public_path__ + "e075e83d7c6d9144df0b110c55a65992.svg";